export default (Vue) => {
  Vue.component('f-crm', () => import('./crm'))
  Vue.component('f-zip', () => import('./zip/zip'))
  Vue.component('f-document', () => import('./document'))
  Vue.component('f-phone', () => import('./phone'))
  Vue.component('f-time', () => import('./time/time'))
}



// WEBPACK FOOTER //
// ./src/components/form/masked/index.js